






import Vue from 'vue';
import Component from 'vue-class-component';
import GTMService, { TrackingLineItem } from './GTM.service';
import { debounce } from 'lodash';
import { BasketViewModel } from '@/types/apiServerContract';
import basketService from '@/project/basket/basket.service';
import { Watch } from 'vue-property-decorator';

@Component
export default class BasketPageTracker extends Vue {
    private hasSendOnce = false;
    private lineItems: TrackingLineItem[] = [];
    private debouncedTrackBasketPage = debounce(this.trackBasketPage, 50);

    private addLineItem(lineItem: TrackingLineItem) {
        const existingIx = this.lineItems.findIndex(li => li.wid === lineItem.wid);
        if (existingIx > -1) {
            this.lineItems[existingIx] = lineItem;
        } else {
            this.lineItems.push(lineItem);
        }
        this.debouncedTrackBasketPage();
    }

    private trackBasketPage() {
        GTMService.trackBasketPage(this.lineItems, !this.hasSendOnce);
        this.hasSendOnce = true;
    }

    private get basket(): BasketViewModel | null {
        return basketService.basketWithCommittedLineItems;
    }

    @Watch('basket')
    private onBasketChange(basket: BasketViewModel, oldBasket: BasketViewModel) {
        if (!this.hasSendOnce) return;
        if (basketService.hasPendingServerUpdates) return; // Only react to final changes from BE

        // Mark line-items no longer in basket - and send ecom.remove event for them
        const itemsRemoved = this.lineItems.filter(li => {
            const lineItemInBasket = basket.lineItems.find(bli => bli.lineItemId === li.lineItemId);
            return !lineItemInBasket;
        });

        // Update local lines
        this.lineItems = this.lineItems.filter(li => !itemsRemoved.includes(li));

        // Update quantity on others
        let quantityChanges = false;
        this.lineItems.forEach(li => {
            const lineItemInBasket = basket.lineItems.find(bli => bli.lineItemId === li.lineItemId);
            if (lineItemInBasket) {
                if (li.quantity !== lineItemInBasket.quantity) {
                    li.quantity = lineItemInBasket.quantity;
                    quantityChanges = true;
                }
            }
        });

        if (itemsRemoved.length) {
            GTMService.trackLineItemsDeleted(itemsRemoved);
        }
        if (itemsRemoved.length || quantityChanges) {
            this.trackBasketPage();
        }
    }
}
